import React from "react"

export default class Topbar extends React.Component {
  render() {
    return (
      <div className="thr-header">
        <a href="/"><img className="logo" src="https://s3-us-west-2.amazonaws.com/cdn.trustmineral-staging.com/assets/MIN-PrimaryLogo-TM-Citrine-RGB-01.png" /></a>
        <span className="tag-line">Developer&#39;s Hub</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/plugins/thinkhr/topbar.jsx